var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_info",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99843242,13.9996382 C3.03638608,13.9838717 -0.111820624,10.7407687 0.0030461456,6.78988634 C0.112769627,3.01517763 3.2045716,-0.026559631 7.05432282,0.000174889958 C10.9315049,0.0272521612 14.038051,3.19375052 13.9996477,7.05654605 C13.9612445,10.9075167 10.8037799,14.0387118 6.99843242,13.9996382 Z M6.93216415,6.00087461 C6.29162886,6.0225951 5.71887672,6.25145878 5.19007529,6.61224249 C5.1453508,6.642747 5.10248337,6.68043844 5.06859179,6.72308087 C4.94788208,6.8751243 4.98920194,7.00385014 5.17119506,7.05288095 C5.24114479,7.07172666 5.3129516,7.08466313 5.38166328,7.10734188 C5.67229514,7.20300786 5.75060171,7.35010029 5.67693783,7.66105464 C5.49773032,8.41695961 5.31496343,9.17206603 5.13885104,9.92876954 C5.00823693,10.4903081 5.28385746,10.9494728 5.80615913,10.991157 C6.5791656,11.0526451 7.26906807,10.7894439 7.88963983,10.3272447 C7.95541115,10.2783736 8.00632589,10.156675 7.99936187,10.0745843 C7.99518345,10.0247549 7.86781922,9.9837096 7.79322681,9.94378223 C7.76181133,9.92701274 7.72374134,9.92381855 7.68876647,9.91407627 C7.34304146,9.81872971 7.25312819,9.66956105 7.33685122,9.31356863 C7.51017799,8.57539141 7.69449245,7.83992926 7.85636728,7.09903699 C7.89474678,6.92367598 7.89737763,6.72212261 7.85435545,6.54915725 C7.75794243,6.16393798 7.43125241,5.98586191 6.93216415,6.00087461 Z M9,3.5163449 C9.0011832,2.67188379 8.3501292,2.00557903 7.51819395,2.00003639 C6.67223843,1.99429579 5.99294642,2.66851861 6.00005529,3.50644732 C6.00716416,4.34160471 6.6692764,4.99722009 7.50871546,5 C8.32722284,5.00276273 8.99861611,4.33467641 9,3.5163449 Z",
    id: "Shape-Copy-5",
    fill: "#D3D3D3",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnInfo);
export default __webpack_public_path__ + "static/media/icn_info.f1c425716d536ee587916aa839adbbfd.svg";
export { ForwardRef as ReactComponent };